/**
 * Allowlisted FE client telemetry UI action names (QPN-2111).
 * Wire values are snake_case for CloudWatch; call sites must use TelemetryActions constants.
 */
const TelemetryActions = Object.freeze({
  LOGIN_SUBMITTED: 'login_submitted',
  SAVE_TESTCASE_CLICKED: 'save_testcase_clicked',
  GENERATE_AI_CLICKED: 'generate_ai_clicked',
  RUN_LAUNCH_CLICKED: 'run_launch_clicked',
  NLP_CONFIG_SAVED: 'nlp_config_saved',
  REPLAY_STARTED_CLICKED: 'replay_started_clicked',
  STOP_AUTOMATION_CLICKED: 'stop_automation_clicked',
});

const TELEMETRY_ACTION_VALUES = Object.freeze(Object.values(TelemetryActions));

const TelemetryEventTypes = Object.freeze({
  ROUTE_CHANGE: 'ROUTE_CHANGE',
  UI_ACTION: 'UI_ACTION',
  CLIENT_ERROR: 'CLIENT_ERROR',
});

const TELEMETRY_EVENT_TYPE_VALUES = Object.freeze(Object.values(TelemetryEventTypes));

module.exports = {
  TelemetryActions,
  TELEMETRY_ACTION_VALUES,
  TelemetryEventTypes,
  TELEMETRY_EVENT_TYPE_VALUES,
};
